export enum LessonRoomGuideCategory {
  Windows = 'WINDOWS',
  Macbook = 'MACBOOK',
  IphoneIpad = 'IPHONE_IPAD',
  Android = 'ANDROID',
}